import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Dash In Circle Stroke
 */

export default function DashInCircleStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.4444 8.55554C12.7513 8.55554 13 8.30681 13 7.99999C13 7.69316 12.7513 7.44443 12.4444 7.44443L3.55556 7.44443C3.24873 7.44443 3 7.69316 3 7.99999C3 8.30681 3.24873 8.55554 3.55556 8.55554H12.4444Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
